import { useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'

const useBillingConfiguration = () => {
  const {
    data: bankAccounts,
    loading: gettingBankAccounts,
    fetchData: fetchBankAccounts,
  } = useFetch(configurationServices.getBankAccounts, { doInitialRequest: true })

  return {
    bankAccounts,
    gettingBankAccounts,
    fetchBankAccounts,
  }
}

export default useBillingConfiguration
